import store from 'redux/store'

export const getWebengageAttributes = () => {
    let state = store.store.getState()
    let {
        stream,
        roll_no,
        test_type,
        class_studying,
        branch_code = '',
        class_opted = '',
        exam_type,
    } = state.queryparam
    let attributes = {
        'Roll number': roll_no,
        Stream: stream,
        'Branch code': branch_code ?? '',
        'Class studying': class_studying,
        'Class opted': class_opted ?? '',
        'Test language': localStorage.getItem('i18nextLng'),
        'Test type': test_type,
        'Exam type': exam_type,
    }
    return { properties: attributes, examType: exam_type }
}

export const getWebengage = () => {
    if (
        typeof window !== 'undefined' &&
        window.webengage &&
        typeof window.webengage === 'object'
    ) {
        return window.webengage
    }
}

export const isWebengageAvailable = () => {
    if (
        typeof window !== 'undefined' &&
        window.webengage &&
        typeof window.webengage === 'object'
    ) {
        return true
    } else {
        return false
    }
}

export const webengageTrackEvent = (eventName, customProperties = {}) => {
    const isPreview =
        sessionStorage.getItem('tp_preview_token') &&
        sessionStorage.getItem('test_id')
            ? true
            : false
    let { properties, examType } = getWebengageAttributes()
    if (!eventName || isPreview) return
    if (isWebengageAvailable()) {
        const we = getWebengage()
        we.track(eventName, { ...properties, ...customProperties })
    }
}

export const webengageLoginUser = (uId) => {
    if (isWebengageAvailable()) {
        const we = getWebengage()
        we.user.login(uId)
    }
}
